import { EmployeeDisplayProps, setApplication } from 'actions/application';
import { ApplicationStatus } from 'enums/ApplicationStatus';
import { ApplicationType } from 'enums/ApplicationType';
import { EmployeePosition } from 'enums/EmployeePosition';
import { LoanInformationVariables } from 'enums/LoanInformationVariables';

import { ApplicationDto } from '../api/ApplicationApi';

export const updateApplicationInStore = (borrowerApplication: ApplicationDto, dispatch: any) => {
  const variables = borrowerApplication.variables;

  const processingStatusSetDate = !!variables.processing_status_set_date
    ? new Date(variables.processing_status_set_date as string)
    : undefined;

  const applicationType = borrowerApplication?.coborrowerIds[0] ? ApplicationType.Joint : ApplicationType.Individual;

  dispatch(
    setApplication({
      applicationId: borrowerApplication?.id,
      displayId: borrowerApplication?.displayId,
      productName: borrowerApplication?.productName,
      intermediaryId: borrowerApplication?.intermediaryId,
      variables: variables,
      [LoanInformationVariables.LoanType]: applicationType,
      [LoanInformationVariables.LoanAmount]: +variables.loan_amount!,
      [LoanInformationVariables.ProcessingStatusSetDate]: processingStatusSetDate,
      [LoanInformationVariables.AssignedConsultant]: {
        name: variables.consultant_sender_name as string,
        position: EmployeePosition.Consultant,
        email: variables.consultant_sender_email as string,
        phone: variables.consultant_sender_phone as string,
      } as EmployeeDisplayProps,
      [LoanInformationVariables.AssignedProcessor]: {
        name: variables.processor_sender_name as string,
        position: EmployeePosition.Processor,
        email: variables.processor_sender_email as string,
        phone: variables.processor_sender_phone as string,
      },
      createdDate: borrowerApplication?.createdAt,
      applicationStatus: borrowerApplication?.status?.name as ApplicationStatus,
      messageFromHFS: variables.message_from_hfs as string,
      messageFromHfsShowOnPortal: variables.message_from_hfs_show_on_portal,
      dashboardAdditionalInfo: borrowerApplication.dashboardAdditionalInfo,
    }),
  );
};
